import HTTPStatus from "../../utils/HTTPStatus";
import { AuthAxiosService } from "../axiosClient";
import { INotificationResponse } from "./INotificationResponse";
import { IAnnouncementRequest } from './IAnnouncementRequest';
import INotificationsRequest from "./INotificationsRequest";
import Pagination from "../Pagination";
import { buildQueryString } from "../../utils/queryString";

class NotificationsService extends AuthAxiosService {
  public async markAsRead(notificationId: number): Promise<void> {
    const response = await this.putAuth<void, void>(
      `/notifications/${notificationId}`,
    );
    return response.data;
  }

  public async markAllAsRead(): Promise<HTTPStatus> {
    const response = await this.putAuth<void, void>(
      `/notifications`,
    );
    return response.status;
  }

  public async getNotifications(request: INotificationsRequest): Promise<{data:Array<INotificationResponse>, pagination: Pagination}> {
    const query = buildQueryString({ page: request.page, pageSize: request.pageSize });
    const response = await this.getAuth<{data:Array<INotificationResponse>, pagination: Pagination}>(
      `/notifications/${query}`
    );
    return response.data;
  }

  public async sendAnnouncement(announcementRequest: IAnnouncementRequest): Promise<void> {
    const response = await this.postAuth<IAnnouncementRequest, void>(
      "/notifications/announcement",
      {
        ...announcementRequest,
      }
    );
    return response.data;
  }

    public async subscribe(subs: PushSubscription): Promise<void> {
    const response = await this.postAuth<any, void>(
      "/notifications/subscribe",
      {
        subscription: subs
      }
    );
    return response.data;
  }

  public async unsubscribe(subs: PushSubscription): Promise<void> {
    const response = await this.postAuth<any, void>(
      "/notifications/unsubscribe",
      {
        subscription: subs
      }
    );
    return response.data;
  }

  public async deleteAll(): Promise<HTTPStatus> {
    const response = await this.deleteAuth<void, void>(
      `/notifications/`,
    );
    return response.status;
  }
}
const notificationsServiceInstance = new NotificationsService();
export default notificationsServiceInstance;
